<script setup lang="ts">
import { computed } from 'vue'
import AppErrorScreen from '~/components/app/AppErrorScreen.vue'
import type { AppErrorScreenModel } from '~/composables/ui/useAppError'

const props = withDefaults(
  defineProps<{
    model: AppErrorScreenModel
    /**
     * Si la description du modèle est vide, afficher ce texte
     * (ex. message d’erreur conservé par la page équipe).
     */
    descriptionFallback?: string
    /** Boundary Nuxt (`clearError` avant navigation), comme sur `app/error.vue`. */
    clearErrorBoundary?: boolean
    /** Hauteur minimale type viewport (boundary globale) ; en page métier laisser `false`. */
    fullHeight?: boolean
  }>(),
  {
    descriptionFallback: '',
    clearErrorBoundary: false,
    fullHeight: false,
  },
)

const resolvedDescription = computed(function computeResolvedDescription(): string {
  const fromModel = props.model.description?.trim() ?? ''
  if (fromModel.length > 0) {
    return props.model.description
  }
  return props.descriptionFallback
})
</script>

<template>
  <AppErrorScreen
    :title="model.title"
    :description="resolvedDescription"
    :illustration-url="model.illustrationUrl"
    :show-back-link="model.showBackButton"
    :show-home-button="model.showHomeButton"
    :show-session-reset="model.showSessionReset"
    :clear-error-boundary="clearErrorBoundary"
    :full-height="fullHeight"
  />
</template>
